<template>
  <div class="score_jl">
    <div class="total">
      积分余额：<span>{{ totalCount }}</span
      >个
        <el-button
          v-if="(authUser.userType === 1 || currentAuthUser.corpUserId) && showFlag"
          @click.stop="integralFn"
          size="mini"
          style="
            display: inline-block;
            margin-left: 30px;
            font-size: 14px;
          ">
          转赠
        </el-button>
        <el-button
          v-if="isBind"
          @click.stop="toByPoint"
          type="primary"
          size="mini">
          充值
        </el-button>
    </div>
    <div class="t_table">
      <!-- 表格内容 -->
      <el-row>
        <el-col>
          <el-table
            :data="listConsole"
            style="border: 1px solid #eeeeee; border-bottom: 0"
            tooltip-effect="dark"
            :header-cell-style="{ background: '#f9f9f9', color: '#000000' }"
          >
            <el-table-column label="日期" prop="pointTime"> </el-table-column>

            <el-table-column
              label="消费详情"
              prop="pointTypeStr"
            ></el-table-column>
            <el-table-column label="积分" prop="point"></el-table-column>
            <no-data text="暂无数据" slot="empty" />
          </el-table>
        </el-col>
      </el-row>
      <!-- 分页栏 -->
      <el-row>
        <el-col style="padding: 30px 0" class="page-flex-end">
          <el-pagination
            @size-change="handleSizeChangeConsole"
            @current-change="handleCurrentChangeConsole"
            :current-page="filterScore.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="filterScore.pageSize"
            layout="sizes, prev, pager, next, total"
            :total="filterScore.pageTotal"
          />
          <el-go
            :page-size="filterScore.pageSize"
            :total="filterScore.pageTotal"
            @current-change="handleCurrentChangeConsole"
          ></el-go>
        </el-col>
      </el-row>
    </div>
    <!-- 转赠窗口   -->
    <el-dialog
      title="转赠积分"
      :visible.sync="integralVisible"
      :close-on-click-modal="false"
      width="30%"
      :rules="integralFormRules"
      class="by_name_dialog"
    >
      <el-form
        ref="integralForm"
        label-width="120px"
        :model="integralData"
        :rules="integralFormRules"
      >
        <el-form-item label="转赠账号" prop="transferTo">
          <el-input
            placeholder="手机号/邮箱"
            v-model="integralData.transferTo"
          />
        </el-form-item>
        <el-form-item label="当前积分" prop="account">
          <span>{{ totalCount }}</span>
        </el-form-item>
        <el-form-item label="转赠积分" prop="transferCount">
          <el-input
            type="text"
            maxlength="9"
            placeholder="请输入转赠积分"
            min="0"
            v-model="integralData.transferCount"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button :loading="submitLoading" @click="integralVisible = false"
          >取 消</el-button
        >
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="integralSubmitFn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElGo from "../../components/go/Go";
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import { isCorp } from "@/assets/js/utils/others";
import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import { mapGetters } from "vuex";
import { configUrl } from "@/assets/js/http-serve/http-methods";
import { isInDingTalk, authentication, isAuthSDKSupport, dingSDKInfo } from "@/assets/js/utils/ding-env";
import { dingtalkApi } from "../../assets/js/http-serve/dingtalkApi";
import { openAuth } from 'dingtalk-design-libs/biz/openAuth';

export default {
  components: { ElGo },
  name: "score",
  data () {
    return {
      DINGSDK: null,
      isInDingTalk,
      filterScore: {
        itemPage: 1,
        pageSize: 10,
        pageTotal: 0,
      },
      listConsole: [],
      totalCount: 0,
      //  转赠
      integralVisible: false,
      integralData: {},
      integralFormRules: {
        transferTo: [
          {
            required: true,
            validator: this.$validator.required,
            trigger: "change",
            message: "请输入转赠账号",
          },
          { validator: this.$validator.mobileOrEmail, trigger: "change" },
        ],
        transferCount: [
          {
            required: true,
            validator: this.$validator.required,
            trigger: "change",
            message: "积分数不能为空"
          },
          { validator: this.$validator.integer, trigger: "change" }
        ],
      },
      submitLoading: false,
    };
  },
  async created () {
    this.gettotal();
    this.getList();
    this.DINGSDK = await this.$DingSDKPromise();
  },
  computed: {
    ...mapGetters(["authUser", "allAuthUser", "currentAuthUser"]),
    showFlag(){
      const {packageRegiftFlag} = this.currentAuthUser
      return (packageRegiftFlag && packageRegiftFlag ==1) ? true : false
    },
    isBind(){
      // console.log('this.allAuthUser.bindCorpUsers',this.allAuthUser.bindCorpUsers);
      const bind = this.allAuthUser.bindCorpUsers.filter(item=>item.corpUserId === this.currentAuthUser.corpUserId)
      return bind.length > 0 ? true : false
    },
  },
  methods: {
    toByPoint () {
      if(this.isInDingTalk){
        return this.dingBuy()
      }
      ApiMethods.accountCenter.getRechargeInfo({}).then(res=>{
        if(!res.success) return this.$message.error(res.description || '获取充值信息失败')
        const {data}=res
        let url = configUrl().accountWeb + "/asset/pointChargePage?rechargeInfo=" + data;
        if (isInDingTalk) {
          url = url + "?dingH5=1";
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = url;
          document.body.append(a);
          a.click();
          setTimeout(() => {
            a.remove();
          }, 1000);
        } else {
          window.open(url, "_blank");
        }
      })
    },
    /** 钉钉购买套餐逻辑 */
    dingPurchasePlan(){
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo")), _this = this;
      const param = { corpId: info.dingTalkCorpId, dingTalkUserId: info.dingTalkUserId }
      dingtalkApi.planSkuLink(param).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        _this.DINGSDK && _this.DINGSDK.biz.util.openSlidePanel({
          url: res.data, //打开侧边栏的url
          title: '应用使用人数', //侧边栏顶部标题
          onSuccess: function (result) { },
          onFail: function () { }
        }).catch((err) => { console.log('catch_err', err); })
      }).finally(() => { _this.loading.close(); })
    },
    /** 钉钉充值授权逻辑 */
    async dingBuy (obj = {}) {
      // 判断该钉钉版本是否支持 使用sdk
      const _this = this,{type} = obj;
      let notVersion = await isAuthSDKSupport()
      if (!notVersion) return _this.$message.error('该钉钉版本较低，请升级客户端后使用')
      // 调用接口，再调用钉钉支付
      this.loading = this.$loading({
        lock: true
      });
      const auth_status = localStorage.getItem('auth_status')
      if (auth_status && auth_status === 'ok') {
        type === 1 ? this.dingPurchasePlan() : this.dingPay()
        return
      }
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      let param = {
        corpId: info.dingTalkCorpId,
        ...dingSDKInfo
      }
      console.log('______param', param);
      openAuth(param).then((res) => {
        // 处理返回数据
        const { status, result } = res;
        switch (status) {
          case 'ok':
            // _this.$message.success('授权成功')
            localStorage.setItem('auth_status', 'ok')
            type === 1 ? _this.dingPurchasePlan() : _this.dingPay()
            return;
          case 'cancel':
            return;
          case 'toAdmin':
            return;
          case 'failed':
            return;
          default:
            return;
        }
      })
    },
    /** 钉钉支付逻辑 */
    dingPay () {
      const info = JSON.parse(sessionStorage.getItem("dingloginInfo")), _this = this;
      const param = { corpId: info.dingTalkCorpId, dingTalkUserId: info.dingTalkUserId }
      dingtalkApi.skuLink(param).then(res => {
        if (!res.success) return _this.$message.error(res.description)
        _this.DINGSDK && _this.DINGSDK.biz.util.openSlidePanel({
          url: res.data, //打开侧边栏的url
          title: '充值', //侧边栏顶部标题
          onSuccess: function (result) { },
          onFail: function () { }
        }).catch((err) => { console.log('catch_err', err); })
      }).finally(() => { _this.loading.close(); })
    },
    //积分转赠
    integralFn () {
      if (this.totalCount >= 10000) {
        this.resetFn();
        this.integralVisible = true;
        this.$nextTick(() => {
          this.$refs.integralForm.clearValidate();
        })
      } else {
        this.$message.error('当前积分小于一万，无法转赠！')
      }
    },
    //积分转赠提交
    integralSubmitFn () {
      this.$refs.integralForm.validate((val) => {
        if (val) {
          this.submitLoading = true;
          ApiCorpMethods.accountOperationController.sendUserPoint(this.integralData).then(res => {
            this.submitLoading = false;
            if (res.success) {
              this.$message.success('操作成功');
              this.$refs.integralForm.clearValidate();
              this.resetFn();
              this.gettotal();
              this.getList();
            } else {
              this.$message.error(res.description || '')
            }
          })
        }
      })
    },
    //重置
    resetFn () {
      this.integralData = {};
      this.integralVisible = false;
    },
    getList () {
      const data = { ...this.filterScore }
      // corpQuery 1:成员查询企业。其他不传这个参数。
      if (isCorp()) data.corpQuery = 1
      console.log('corpData', data);
      ApiMethods.ProfileController.userPointHistory(data)
        .then((res) => {
          if (res.code === "0") {
            this.listConsole = res.data;
            this.filterScore.pageTotal = res.total;
          } else {
            this.listConsole = [];
            this.filterScore.pageTotal = 0;
            this.$message.error(res.description || "获取消费记录数据失败");
          }
        })
        .catch((error) => {
          console.info(error);
          this.$message.error(error);
        });
    },
    handleSizeChangeConsole (val) {
      this.filterScore.itemPage = 1;
      this.filterScore.pageSize = val;
      this.getList();
    },
    handleCurrentChangeConsole (val) {
      this.filterScore.itemPage = val;
      this.getList();
    },
    gettotal () {
      // corpQuery 1:成员查询企业。其他不传这个参数。
      ApiMethods.ProfileController.userPoint(isCorp() ? { corpQuery: 1 } : {})
        .then((res) => {
          if (res.code === "0") {
            this.totalCount = res.data;
          } else {
            this.$message.error(res.description || "获取消费总量据失败");
          }
        })
        .catch((error) => {
          console.info(error);
          this.$message.error(error);
        });
    }
  },
};
</script>

<style lang="less" scoped>
.score_jl {
  padding-top: 20px;
  /*height: calc(100vh - 340px);*/
  /*overflow-y: auto;*/
  .total {
    height: 100px;
    line-height: 100px;
    border: 1px solid #d2d2d2;
    width: 90%;
    margin: 0 auto;
    padding-left: 15px;
    font-size: 14px;
    color: #525250;
    span {
      font-size: 30px;
      // color: rgb(16, 160, 233);
    }
  }
  .t_table {
    width: 90%;
    margin: 50px auto;
  }
}

.go-style {
  top: 32px !important;
}
</style>



// WEBPACK FOOTER //
// pages/tpl/score.vue